// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WjiKEV7dB01lXJKGJZVY {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.WjiKEV7dB01lXJKGJZVY .LmrRZVFyOsyCwB2rivqe {
    width: 100%;
}

.WjiKEV7dB01lXJKGJZVY .LmrRZVFyOsyCwB2rivqe + .LmrRZVFyOsyCwB2rivqe {
    margin-left: 16px;
}

.LmrRZVFyOsyCwB2rivqe input {
    color: black;
}

.UHP6KeYWiTfrBYdiFBfC input {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
}

.RfQqPYnPQ6T1dnaU41tx {
    font-size: 12px;
    margin-top: 4px;
    text-align: left;
}

.UHP6KeYWiTfrBYdiFBfC .RfQqPYnPQ6T1dnaU41tx {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}
}

.grJZBICj1ywEEqyHp0Oe {
    font-size: 12px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin-left: 4px;
}

.SuF3sX6dKwh5SBMdXfBS {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
}

@media screen and (max-width: 425px) {
    .WjiKEV7dB01lXJKGJZVY {
        flex-wrap: wrap;
    }

    .WjiKEV7dB01lXJKGJZVY .LmrRZVFyOsyCwB2rivqe + .LmrRZVFyOsyCwB2rivqe {
        margin-left: 0;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/library/Input/LocationInput/LocationInput.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0DAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,mDAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-error, color-text-subtle from colors;\n\n.row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.row .inputContainer {\n    width: 100%;\n}\n\n.row .inputContainer + .inputContainer {\n    margin-left: 16px;\n}\n\n.inputContainer input {\n    color: black;\n}\n\n.error input {\n    border-color: color-error;\n}\n\n.hint {\n    font-size: 12px;\n    margin-top: 4px;\n    text-align: left;\n}\n\n.error .hint {\n    color: color-error\n}\n\n.unrequired {\n    font-size: 12px;\n    color: color-text-subtle;\n    margin-left: 4px;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    row-gap: 0.5rem;\n}\n\n@media screen and (max-width: 425px) {\n    .row {\n        flex-wrap: wrap;\n    }\n\n    .row .inputContainer + .inputContainer {\n        margin-left: 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"row": `WjiKEV7dB01lXJKGJZVY`,
	"inputContainer": `LmrRZVFyOsyCwB2rivqe`,
	"error": `UHP6KeYWiTfrBYdiFBfC`,
	"hint": `RfQqPYnPQ6T1dnaU41tx`,
	"unrequired": `grJZBICj1ywEEqyHp0Oe`,
	"container": `SuF3sX6dKwh5SBMdXfBS`
};
export default ___CSS_LOADER_EXPORT___;
